const styles = () => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  optional: {
    marginLeft: '5px',
    color: '#a5a5a5'
  }
})

export default styles
